import * as XLSX from "xlsx-js-style";

export const PSRreportExcel = (
  data = [],
  filters = {},
  projectName = "",
  managerName = "",
  employeeTaskData = [],
  projectTaskData = []
) => {
  if (!Array.isArray(data) || data.length === 0) return;

  const ws = XLSX.utils.aoa_to_sheet([]);
  ws["!merges"] = [];
  let currentRow = 0;

  const DESCRIPTION_COL_INDEX = 4;

  /* =====================================================
     STYLES
  ===================================================== */

  const titleStyle = {
    font: { bold: true, sz: 16 },
    alignment: { horizontal: "center", vertical: "center" },
    fill: { fgColor: { rgb: "BDD7EE" } }
  };

  const subTitleStyle = {
    font: { bold: true },
    alignment: { horizontal: "center" }
  };

  const headerStyle = {
    font: { bold: true },
    alignment: { horizontal: "center", vertical: "center", wrapText: true },
    fill: { fgColor: { rgb: "E9EFF7" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };

  const rowStyleCenter = {
    alignment: { horizontal: "center", vertical: "center", wrapText: true },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };

  const rowStyleLeft = {
    alignment: { horizontal: "left", vertical: "center", wrapText: true },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };

  /* =====================================================
     HELPERS
  ===================================================== */

  const addEmptyRow = (count = 1) => {
    currentRow += count;
  };

  const addMergedRow = (text, style = subTitleStyle) => {
    XLSX.utils.sheet_add_aoa(ws, [[text]], { origin: `A${currentRow + 1}` });
    ws[`A${currentRow + 1}`].s = style;
    ws["!merges"].push({ s: { r: currentRow, c: 0 }, e: { r: currentRow, c: 9 } });
    currentRow++;
  };

  const addSplitRow = (leftText = "", rightText = "") => {
    XLSX.utils.sheet_add_aoa(
      ws,
      [[leftText, "", "", "", "", rightText]],
      { origin: `A${currentRow + 1}` }
    );

    ws[`A${currentRow + 1}`].s = { font: { bold: true }, alignment: { horizontal: "left" } };
    ws[`F${currentRow + 1}`].s = { font: { bold: true }, alignment: { horizontal: "right" } };

    ws["!merges"].push(
      { s: { r: currentRow, c: 0 }, e: { r: currentRow, c: 4 } },
      { s: { r: currentRow, c: 5 }, e: { r: currentRow, c: 9 } }
    );
    currentRow++;
  };

  const addMergedLeftRow = (text) => {
    XLSX.utils.sheet_add_aoa(ws, [[text]], { origin: `A${currentRow + 1}` });
    ws[`A${currentRow + 1}`].s = { font: { bold: true }, alignment: { horizontal: "left" } };
    ws["!merges"].push({ s: { r: currentRow, c: 0 }, e: { r: currentRow, c: 9 } });
    currentRow++;
  };

  /* =====================================================
     HEADER
  ===================================================== */

  addMergedRow(`Project Report - ${filters.EmployeeID || ""}`, titleStyle);
  addEmptyRow();
  addMergedLeftRow(`Project: ${projectName || ""}`);
  addSplitRow(`Manager: ${managerName || "-"}`, "E.Hrs – Estimated Hours");
  addSplitRow("Comp – Completed | Appr – Approved", "A.Hrs – Actual Hours");
  addEmptyRow();

  /* =====================================================
     MAIN TASK TABLE
  ===================================================== */
const mainTable = data.map((r, i) => ({
  "SL#": String(i + 1),
  Date: String(r.DATE),
  Project: String(r.ProjectCode),
  Employee: String(r.EmployeeName),
  Description: r.Comments, // keep text
  "E.Hrs": String(r.EStimatedHourse),
  "A.Hrs": String(r.ActualHourse),
  "Comp Date": String(r.CurrectCompletedDate),
  "Appr By": String(r.ManagerCode),
  "Appr Date": String(r.ApprovedDate)
}));

  // const mainTable = data.map((r, i) => ({
  //   "SL#": i + 1,
  //   Date: r.DATE,
  //   Project: r.ProjectCode,
  //   Employee: r.EmployeeName,
  //   Description: r.Comments,
  //   "E.Hrs": r.EStimatedHourse,
  //   "A.Hrs": r.ActualHourse,
  //   "Comp Date": r.CurrectCompletedDate,
  //   "Appr By": r.ManagerCode,
  //   "Appr Date": r.ApprovedDate
  // }));

  XLSX.utils.sheet_add_json(ws, mainTable, { origin: `A${currentRow + 1}` });

  const mainHeaderRow = currentRow;

  for (let R = mainHeaderRow; R <= mainHeaderRow + mainTable.length; R++) {
    for (let C = 0; C <= 9; C++) {
      const cell = XLSX.utils.encode_cell({ r: R, c: C });
      if (!ws[cell]) continue;

      if (R === mainHeaderRow) {
        ws[cell].s = headerStyle;
      } else {
        ws[cell].s =
          C === DESCRIPTION_COL_INDEX ? rowStyleLeft : rowStyleCenter;
      }
    }
  }

  currentRow += mainTable.length + 2;

  /* =====================================================
     EMPLOYEE TASKS
  ===================================================== */

  addMergedRow("Employee Tasks Efforts");
  addEmptyRow();

  XLSX.utils.sheet_add_json(
    ws,
    employeeTaskData.map((r, i) => ({
      "SL#": i + 1,
      Project: r.ProjectName,
      Employee: r.EmployeeName,
      "Total E.Hrs": r.TotalEstimatedHours,
      "Total A.Hrs": r.TotalActualHours
    })),
    { origin: `A${currentRow + 1}` }
  );

  const empHeaderRow = currentRow;

  for (let R = empHeaderRow; R <= empHeaderRow + employeeTaskData.length; R++) {
    for (let C = 0; C <= 4; C++) {
      const cell = XLSX.utils.encode_cell({ r: R, c: C });
      if (!ws[cell]) continue;
      ws[cell].s = R === empHeaderRow ? headerStyle : rowStyleCenter;
    }
  }

  currentRow += employeeTaskData.length + 2;

  /* =====================================================
     PROJECT TASKS
  ===================================================== */

  addMergedRow("Project Tasks Efforts");
  addEmptyRow();

  XLSX.utils.sheet_add_json(
    ws,
    projectTaskData.map((r, i) => ({
      "SL#": i + 1,
      Project: r.ProjectName,
      "Total E.Hrs": r.TotalEstimatedHours,
      "Total A.Hrs": r.TotalActualHours
    })),
    { origin: `A${currentRow + 1}` }
  );

  const prjHeaderRow = currentRow;

  for (let R = prjHeaderRow; R <= prjHeaderRow + projectTaskData.length; R++) {
    for (let C = 0; C <= 3; C++) {
      const cell = XLSX.utils.encode_cell({ r: R, c: C });
      if (!ws[cell]) continue;
      ws[cell].s = R === prjHeaderRow ? headerStyle : rowStyleCenter;
    }
  }

  /* =====================================================
     EXPORT
  ===================================================== */

  ws["!cols"] = [
    { wch: 4 },
    { wch: 14 },
    { wch: 16 },
    { wch: 18 },
    { wch: 40 }, // Description
    { wch: 10 },
    { wch: 10 },
    { wch: 14 },
    { wch: 14 },
    { wch: 14 }
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "PSR Report");
  XLSX.writeFile(wb, "PSR_Report.xlsx");
};

export default PSRreportExcel;
